/**
 * @file paddle Wave Summit 2020 图文卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { Col, Popover } from 'antd';

import A from '../../../../components/a/A';

import { ILiveCardItem } from './types';

const LiveCard: React.FC<ILiveCardItem> = React.memo((props) => {
    const [titleRowNum, setTitleRowNum] = useState<number>(1);
    const titleRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (titleRef.current) {
            const titleCss = window.getComputedStyle(titleRef.current);
            if (titleCss.lineHeight !== titleCss.height) {
                setTitleRowNum(2);
            }
            else {
                setTitleRowNum(1);
            }
        }
    }, [props]);

    const [
        theLink,
        theBtnText
    ] = useMemo(() => {
        if (props.liveState === 'before') {
            return [props.beforeLink, props.beforeBtnText];
        }
        if (props.liveState === 'after') {
            return [props.afterLink, props.afterBtnText];
        }
        if (props.liveState === 'current') {
            return [props.link, props.btnText];
        }
        return ['', ''];
    }, [
        props.liveState,
        props.beforeBtnText,
        props.beforeLink,
        props.afterBtnText,
        props.afterLink,
        props.btnText,
        props.link
    ]);

    return (
        <Col
            xs={6}
            className="paddle-live-live-card-grid"
        >
            <A
                href={theLink}
                target
                className="paddle-live-live-card clear-both"
            >
                <div className="paddle-live-live-card-body">
                    <Popover content={props.title} trigger="hover">
                        <div
                            ref={titleRef}
                            className={classNames(
                                'paddle-live-live-card-title',
                                {
                                    'paddle-live-live-card-title-multi-row': titleRowNum > 1
                                }
                            )}
                        >
                            {props.title}
                        </div>
                    </Popover>
                    
                    <div className="paddle-live-live-card-content">
                        <span className="paddle-live-live-card-content-author">{props.author}</span>
                        <span>{props.authorTitle}</span>
                    </div>

                    <div className="paddle-live-live-card-tags">
                        {!!props.startTime
                            && (
                                <div className="paddle-live-live-card-tag paddle-live-live-card-tag-time">
                                    <span className="paddle-live-live-card-tag-icon paddle-live-live-card-tag-icon-time" />
                                    {props.startTime.calendar(null, {
                                        sameDay: '[今天] HH:mm',
                                        nextDay: '[明天] HH:mm',
                                        nextWeek: 'dddd',
                                        lastDay: '[昨天] HH:mm',
                                        lastWeek: '[上个] dddd',
                                        sameElse: 'YY.MM.DD HH:mm'
                                    })}
                                </div>
                            )
                        }
                        {
                            <div className="paddle-live-live-card-tag">
                                <span className="paddle-live-live-card-tag-icon paddle-live-live-card-tag-icon-address" />
                                {!props.offlineAddress ? '线上直播' : '线下·' + props.offlineAddress}
                            </div>
                        }
                        {!!theBtnText
                            && (
                                <div className="paddle-live-live-card-tag paddle-live-live-card-link">
                                    {`${theBtnText}`}
                                </div>
                            )
                        }
                    </div>
                </div>
            </A>
        </Col>
    );
});

export default LiveCard;
